import * as types from 'constants/actionTypes'

export const setLastApp = (lastApp) => ({ type: types.SET_LAST_APP, lastApp })



// WEBPACK FOOTER //
// ./src/actions/lastAppAC.js